export default "__VITE_ASSET__CBums4jd__"